<script lang="ts" setup>
import { defineComponent, defineEmits } from 'vue'

import USButton from '@base/components/USButton/USButton.vue'

import ProfilePictureInput from '@player/_components/ProfilePictureInput/ProfilePictureInput.vue'
import SplitContent from '@player/_components/SplitContent/SplitContent.vue'

defineComponent({
  name: 'RegisterStep3'
})

const emits = defineEmits(['next', 'previous', 'uploadAvatar'])

const handleUploadAvatar = (e: any) => {
  emits('uploadAvatar', e)
}
</script>

<template>
  <div class="register-step-3">
    <SplitContent
      :sticky="true"
      top-offset="var(--player-header-height)"
      class="margin-top--5 margin-bottom--5"
    >
      <template #left>
        <div class="register-step-3__form-wrapper">
          <h1 class="heading--h3 margin-bottom--8">
            Step 3: Set up your profile
          </h1>
          <p class="body--p1--regular margin-bottom--5">
            Add a profile picture to personalize your UpSwing profile! For best
            quality, use a minimum of a 200x200 pixel photo.
          </p>
          <div class="register-step-3__buttons">
            <div>
              <USButton is="button" label="Next" @click="$emit('next')" />
            </div>
            <div>
              <USButton
                is="button"
                type="inline"
                label="I'll do this later"
                @click="$emit('next')"
              />
            </div>
          </div>
        </div>
      </template>
      <template #right>
        <div class="register-step-3__right">
          <ProfilePictureInput
            input-name="profilePicture"
            @upload="handleUploadAvatar"
          />
        </div>
      </template>
    </SplitContent>
  </div>
</template>

<style lang="scss" scoped>
@use '@base/styles/v1.0/scss/foundations/breakpoint' as bp;

.register-step-3 {
  color: var(--color--neutral-a1);

  &__input {
    margin-bottom: var(--spacing--6);
  }

  &__right {
    margin-top: var(--spacing--5);

    @include bp.min-width(bp.$breakpoint--7) {
      margin-top: 0;
    }
  }

  &__buttons {
    align-items: center;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
  }
}

:deep(.split-content__content) {
  flex-flow: column-reverse;

  @media (min-width: bp.$breakpoint--tablet) {
    flex-flow: row wrap;
  }
}
</style>
